// Google AdSense on the website only.
// Google does not allow AdSense inside mobile apps (WebViews), so the Android/iOS apps never load it
// (they show the admin's own ads from Admin > Ads; Google ads in apps need AdMob).
import { isNativeApp } from './platform';

const SCRIPT_ID = 'sq-adsense';
// Pages without publisher content or where an ad could be clicked by mistake get no AdSense script.
const NO_ADS = [/^\/admin/, /^\/login/, /^\/register/, /^\/forgot-password/, /^\/reset-password/, /^\/quiz/,
  /^\/privacy/, /^\/terms/, /^\/rewards-rules/, /^\/official-rules/, /^\/groups\/join/];

export function adsAllowedOn(pathname) {
  return !NO_ADS.some((re) => re.test(pathname || '/'));
}

export function isValidClientId(id) {
  return /^ca-pub-\d{10,20}$/.test(id || '');
}

// Adds the AdSense script (and the site-ownership meta tag) once. Returns true when it is on the page.
export function loadAdSense(clientId, doc = document) {
  if (isNativeApp() || !isValidClientId(clientId)) return false;
  if (doc.getElementById(SCRIPT_ID)) return true;
  if (!doc.querySelector('meta[name="google-adsense-account"]')) {
    const meta = doc.createElement('meta');
    meta.name = 'google-adsense-account';
    meta.content = clientId;
    doc.head.appendChild(meta);
  }
  const s = doc.createElement('script');
  s.id = SCRIPT_ID;
  s.async = true;
  s.crossOrigin = 'anonymous';
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`;
  doc.head.appendChild(s);
  return true;
}

let configPromise = null;
// Public AdSense settings, fetched once per page load.
export function getAdSenseConfig(fetchConfig) {
  if (!configPromise) {
    try {
      configPromise = Promise.resolve(fetchConfig())
        .then((res) => res?.data?.google_adsense || { enabled: false })
        .catch(() => ({ enabled: false }));
    } catch (e) {
      return Promise.resolve({ enabled: false }); // no ads rather than a broken page
    }
  }
  return configPromise;
}

export function resetAdSenseConfigForTests() {
  configPromise = null;
}
